import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { UpdateFournisseurAgree } from "../../core/model/fournisseuragree/update-fournisseur-agree";
import { MarcheDTO } from "../../core/model/marche/marche-dto";
import { FournisseurAgreeDTO } from "../../core/model/fournisseuragree/fournisseur-agree-dto";
import { MarcheService } from "../../core/service/marche.service";
import { FournisseurAgreeService } from "../../core/service/fournisseur-agree.service";

@Component({
  selector: "app-edit-fournisseur-agree",
  templateUrl: "./edit-fournisseur-agree.component.html",
  styleUrls: ["./edit-fournisseur-agree.component.scss"],
})
export class EditFournisseurAgreeComponent implements OnInit {
  @Input() id;

  updateFournisseurAgree: UpdateFournisseurAgree = new UpdateFournisseurAgree();
  marches: MarcheDTO[];
  fournisseurAgreeDTO: FournisseurAgreeDTO;
  loading = true;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _marcheService: MarcheService,
    private _fournisseurAgreeService: FournisseurAgreeService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      marcheId: [null, Validators.compose([Validators.required])],
      codeClient: [null, Validators.compose([Validators.required])],
      numeroRct: [null, Validators.compose([Validators.required])],
      nomComplet: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.findById(this.id);
    this.getMarches();
  }

  findById(id) {
    this.loading = true;
    this._fournisseurAgreeService.findById(id).subscribe(
      (data) => {
        this.fournisseurAgreeDTO = data;
        this.updateFournisseurAgree = {
          ...this.updateFournisseurAgree,
          fournisseurAgreeId: this.fournisseurAgreeDTO.id,
          marcheId: this.fournisseurAgreeDTO.marche
            ? this.fournisseurAgreeDTO.marche.id
            : null,
          codeClient: this.fournisseurAgreeDTO.codeClient,
          nomComplet: this.fournisseurAgreeDTO.nomComplet,
          numeroRct: this.fournisseurAgreeDTO.numeroRct,
        };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getMarches() {
    this._marcheService.findAll().subscribe(
      (data) => {
        this.marches = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._fournisseurAgreeService
      .update(this.updateFournisseurAgree)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close(this.updateFournisseurAgree);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
